/* MOREOVER homepage: preserve sticky header, switch its presentation on scroll and announcement hover. */
(function () {
  function init() {
    if (!document.querySelector('.mrvr-hero')) return;
    var header = document.querySelector('.section-header');
    if (!header || header.dataset.mrvrInteractiveHeader === 'true') return;
    header.dataset.mrvrInteractiveHeader = 'true';
    var announcement = document.querySelector('.announcement-bar');
    var announcementHovered = false;
    function measure() {
      document.documentElement.style.setProperty('--mrvr-header-overlap', Math.ceil(header.getBoundingClientRect().height) + 'px');
    }
    function sync() {
      header.classList.toggle('mrvr-header-active', window.scrollY > 16 || announcementHovered);
    }
    if (announcement) {
      announcement.addEventListener('pointerenter', function () { announcementHovered = true; sync(); });
      announcement.addEventListener('pointerleave', function () { announcementHovered = false; sync(); });
      announcement.addEventListener('focusin', function () { announcementHovered = true; sync(); });
      announcement.addEventListener('focusout', function () { announcementHovered = false; sync(); });
    }
    window.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', function () { measure(); sync(); }, { passive: true });
    window.addEventListener('pageshow', function () { measure(); sync(); });
    measure();
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
